<template>
  <q-dialog :visible="isVisible" :title="title" width="700px" :innerScroll="false" :showFooter="false" @close="onCancel">
    <div class="content">
      <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="100px" size="small">
        <el-row>
          <el-col :span="24" align="left" v-if="fileList.length == 1">
            <el-form-item label="报告时间" prop="qualityDate">
              <el-date-picker v-model="requestParam.qualityDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择时间" />
            </el-form-item>
          </el-col>
          <el-col :span="24" align="left">
            <el-form-item label="附件" prop="goodsCode">
              <el-upload
                class="upload-demo"
                ref="upload"
                accept=".pdf,.docx"
                :limit="100"
                multiple
                action=""
                :http-request="httpRequest"
                :on-remove="handleRemove"
                :headers="headers"
                :file-list="fileList"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
              >
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-button
                  style="margin-left: 10px"
                  v-loading.fullscreen.lock="fjLoading"
                  element-loading-text="数据导入中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  size="small"
                  type="success"
                  @click="checkFormValid"
                  >上传
                </el-button>
                <div slot="tip" class="el-upload__tip">只能上传word/pdf文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="footer">
      <el-button @click="onCancel" size="medium">取 消</el-button>
    </div>
  </q-dialog>
</template>

<script>
import { getToken } from '@/utils/auth';
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '质检报告导入';
    },
  },
  data() {
    return {
      loading: false,
      fjLoading: false,
      requestParam: {
        qualityDate: '',
      },
      rules: {},
      headers: {
        Authorization: getToken(),
        fileType: 81,
      },
      tableData: {
        records: [],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      visibleColumns: [],
      fileList: [],
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
      this.fileList = [];
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      console.log(file, fileList);
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.cancel();
      this.handleSearch();
    },
    // 验证
    beforeUpload(file) {
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (['pdf', 'doc', 'docx'].indexOf(pattern.toLowerCase()) === -1) {
        this.$message.error('请上传后缀名为.pdf,.docx的附件！');
        return false;
      }
      // this.fileList = [];
      this.fileList.push(file);
    },
    checkFormValid(file) {
      this.$refs['requestParam'].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error('参数校验失败！');
        }
      });
    },
    submitUpload(file) {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请先上传附件');
        return;
      }
      this.fjLoading = true;
      var formDataImport = new FormData();
      this.fileList.forEach((v,index)=>{
        formDataImport.append('file', this.fileList[index]);
      })
      formDataImport.append('fileType', 91);
      this.requestParam.qualityDate && formDataImport.append('qualityDate', this.requestParam.qualityDate);
      this.$q.refundManagement
        .fileUpload({ data: formDataImport })
        .then((res) => {
          this.fjLoading = false;
          if (res.code == 200 && res.success) {
            this.$message.success('数据导入中，请稍后查看');
            this.onCancel();
            this.$emit('success');
          }
          this.cancel();
          if (res.code == 200 && !res.success) return;
          this.handleSearch();
          this.$refs.upload.submit();
        })
        .catch((err) => {
          this.fjLoading = false;
        });
    },
  },
  created() {},
};
</script>

<style lang="stylus" scoped>
.header {
  display: flex
  height: 40px
  align-items: center
  justify-content: space-between
  padding-bottom: 10px
}

.footer {
  text-align: center
  margin-top: 10px
}

>>> .el-form-item--mini{
  width: 280px;
  margin-bottom: 0
}

>>> .el-dialog {
  margin-top: 50px !important
}

>>> .el-upload-list {
  max-height: 50vh
  overflow-y: auto
}
</style>
